module.exports = __webpack_public_path__ + "img/logo.fedb7d57.png";